import React from 'react';
import { CONTACT_FORM_URL } from './AppConstant';

const servicesData = [
  {
    icon: 'fas fa-code',
    title: 'Client Projects',
    description: 'Building tech solutions through student-driven projects.',
    delay: '.3s',
    redirelink:  'contact',         //CONTACT_FORM_URL,
    isContact: true,
  },
  // {
  //   icon: 'fas fa-code',
  //   title: 'Internship Programs',
  //   description: 'Project-based Internships with stipends & mentorship.',
  //   delay: '.7s',
  //   redirelink: '#',
  //   isContact: false, // Set to false to show "Apply"
  // },
  {
    icon: 'fas fa-external-link-alt',
    title: 'Local Digitization',
    description: 'Bringing shops & hotels online with digital solutions.',
    delay: '.7s',
    redirelink:  '/contact',      //CONTACT_FORM_URL,
    isContact: true,
  },
  // {
  //   icon: 'fas fa-user-secret',
  //   title: 'Student Training',
  //   description: 'Skilling students with industry-relevant training.',
  //   delay: '.3s',
  //   redirelink: CONTACT_FORM_URL,
  //   isContact: false,
  // },
];

const FocusArea = () => {
  return (
    <div className="services py-5 mb-5 w-100">
      <div
        className="mx-auto"
        style={{
          width: '100%',
          maxWidth: '100%',
          paddingLeft: '15px',
          paddingRight: '15px',
        }}
      >
        <div
          className="mx-auto"
          style={{
            width: '100%',
            maxWidth: '1200px',
          }}
        >
          <div
            className="text-center pb-5 wow fadeIn"
            data-wow-delay=".3s"
            style={{
              maxWidth: '600px',
              margin: '0 auto',
            }}
          >
            <h1>Our Focus Area</h1>
          </div>

          <div
            className="row g-3 justify-content-center"
            style={{
              margin: '0 auto',
              width: '100%',
            }}
          >
            {servicesData.map((service, index) => (
              <div
                className="col-12 col-sm-6 col-md-6 col-lg-3 wow fadeIn"
                data-wow-delay={service.delay}
                key={index}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <div className="services-item bg-light h-100" style={{ width: '100%', maxWidth: '100%' }}>
                  <div className="p-4 text-center services-content">
                    <div className="services-content-icon">
                      <i className={`fa ${service.icon} fa-7x mb-4 text-primary`}></i>
                      <h4 className="mb-3">{service.title}</h4>
                      <p className="mb-4">{service.description}</p>
                      <a
                        href={service.redirelink}
                        className="btn btn-secondary text-white px-5 py-3 rounded-pill"
                      >
                        {service.isContact ? 'Contact' : 'Apply'}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default FocusArea;
